/**
 * Fiscal-year rate registry. To add a new FY:
 *  1. Create `fy-<year>.ts` next to this file with a `RATES_FY_<year>` export.
 *  2. Add it to the `RATES_BY_FY` map below.
 *  3. Update `DEFAULT_FISCAL_YEAR` if the new FY is the current one.
 *
 * Rates from past FYs are immutable — never mutate a published file.
 */

import type { FiscalYear, RatesSnapshot } from "../types.js";
import { RATES_FY_2081_82 } from "./fy-2081-82.js";

/** All FYs currently shipped in the package. */
export const RATES_BY_FY: ReadonlyMap<FiscalYear, RatesSnapshot> = new Map([
  ["2081/82", RATES_FY_2081_82],
]);

/** The default fiscal year used when callers don't pass `fiscalYear`. */
export const DEFAULT_FISCAL_YEAR: FiscalYear = "2081/82";

/** Resolve rates for a given fiscal year, defaulting to the current FY. */
export function getRates(fiscalYear: FiscalYear = DEFAULT_FISCAL_YEAR): RatesSnapshot {
  const r = RATES_BY_FY.get(fiscalYear);
  if (!r) {
    throw new RangeError(
      `getRates: fiscal year "${fiscalYear}" not supported. Available: ${[...RATES_BY_FY.keys()].join(", ")}`,
    );
  }
  return r;
}

/** All supported fiscal years in the registry. */
export function getSupportedFiscalYears(): FiscalYear[] {
  return [...RATES_BY_FY.keys()];
}

export { RATES_FY_2081_82 };
